import { render } from "./AudioPLayer.vue?vue&type=template&id=77a6cb32&scoped=true&lang=pug"
import script from "./AudioPLayer.vue?vue&type=script&lang=js"
export * from "./AudioPLayer.vue?vue&type=script&lang=js"

import "./AudioPLayer.vue?vue&type=style&index=0&id=77a6cb32&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a6cb32"]])

export default __exports__